// import React from "react";
// import locationPin from "../assets/icons/location pin.png"
// import phone from "../assets/icons/phone.png"
// import email from "../assets/icons/email.png"

// export default function ContactSection() {
//   return (
//     <section id="contact" className="bg-[#7533AF]">
//       <div className="max-w-6xl mx-auto px-4 md:px-8">
//         <div className="py-16 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
//           {/* Left */}
//           <div className="text-white">
//             <h2 className="text-3xl md:text-4xl font-bold leading-tight">
//               Ready to Transform Your <br /> Business?
//             </h2>
//             <p className="mt-3 text-white/80 text-sm max-w-md">
//               Get in touch with our team. We’re here to help you succeed.
//             </p>

//             <div className="mt-8 space-y-4 text-sm">
//               <div className="flex gap-4">
//                 <img src={locationPin} alt="" className="h-8" />
//                 <div>
//                   <div className="font-semibold">Address</div>
//                   <div className="text-white/80">123 Business Street, Tech City, TC 12345</div>
//                 </div>
//               </div>

//               <div className="flex gap-4">
//                 <img src={phone} alt="" className="h-8" />
//                 <div>
//                   <div className="font-semibold">Phone</div>
//                   <div className="text-white/80">+1 (800) 123-4567</div>
//                 </div>
//               </div>

//               <div className="flex gap-4">
//                 <img src={email} alt="" className="h-8"/>
//                 <div>
//                   <div className="font-semibold">Email</div>
//                   <div className="text-white/80">support@playanddine.com</div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Right Form */}
//           <div className="bg-white rounded-lg shadow-lg p-6 md:p-8">
//             <div className="space-y-4">
//               <div>
//                 <label className="text-xs font-semibold text-slate-700">Full Name</label>
//                 <input
//                   className="mt-1 w-full rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-[#7533AF]/30"
//                   placeholder="John Doe"
//                 />
//               </div>

//               <div>
//                 <label className="text-xs font-semibold text-slate-700">Email Address</label>
//                 <input
//                   className="mt-1 w-full rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-[#7533AF]/30"
//                   placeholder="john@example.com"
//                 />
//               </div>

//               <div>
//                 <label className="text-xs font-semibold text-slate-700">Phone Number</label>
//                 <input
//                   className="mt-1 w-full rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-[#7533AF]/30"
//                   placeholder="+1 (800) 123-4567"
//                 />
//               </div>

//               <div>
//                 <label className="text-xs font-semibold text-slate-700">Message</label>
//                 <textarea
//                   rows="4"
//                   className="mt-1 w-full rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-[#7533AF]/30"
//                   placeholder="Tell us about your venue..."
//                 />
//               </div>

//               <button className="w-full rounded-lg bg-[#7533AF] px-5 py-2 text-sm font-semibold text-white hover:opacity-90 shadow-sm">
//                 Send Message
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }
import React, { useState } from "react";
import locationPin from "../assets/icons/location pin.png";
import phoneIcon from "../assets/icons/phone.png";
import emailIcon from "../assets/icons/email.png";

export default function ContactSection() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: "", msg: "" }); // type: success|error

  // ✅ change this to your actual endpoint path
  const API_URL = "https://snooker.methologik.com/api-email.php";

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setStatus({ type: "", msg: "" });

    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
      setStatus({ type: "error", msg: "Name, Email and Message are required." });
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const data = await res.json();

      if (data?.success) {
        setStatus({ type: "success", msg: "Message sent successfully!" });
        setForm({ name: "", email: "", phone: "", message: "" });
      } else {
        setStatus({ type: "error", msg: data?.message || "Failed to send message." });
      }
    } catch (err) {
      setStatus({ type: "error", msg: "Network error. Please try again." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" className="bg-[#7533AF]">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="py-16 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          {/* Left */}
          <div className="text-white">
            <h2 className="text-3xl md:text-4xl font-bold leading-tight">
              Ready to Transform Your <br /> Business?
            </h2>
            <p className="mt-3 text-white/80 text-sm max-w-md">
              Get in touch with our team. We’re here to help you succeed.
            </p>

            <div className="mt-8 space-y-4 text-sm">
              <div className="flex gap-4">
                <img src={locationPin} alt="" className="h-8" />
                <div>
                  <div className="font-semibold">Address</div>
                  <div className="text-white/80">
                    123 Business Street, Tech City, TC 12345
                  </div>
                </div>
              </div>

              <div className="flex gap-4">
                <img src={phoneIcon} alt="" className="h-8" />
                <div>
                  <div className="font-semibold">Phone</div>
                  <div className="text-white/80">+1 (800) 123-4567</div>
                </div>
              </div>

              <div className="flex gap-4">
                <img src={emailIcon} alt="" className="h-8" />
                <div>
                  <div className="font-semibold">Email</div>
                  <div className="text-white/80">support@playanddine.com</div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Form */}
          <div className="bg-white rounded-lg shadow-lg p-6 md:p-8">
            <form className="space-y-4" onSubmit={onSubmit}>
              {/* status message */}
              {status.msg && (
                <div
                  className={`rounded-lg px-3 py-2 text-sm ${
                    status.type === "success"
                      ? "bg-green-50 text-green-700 border border-green-200"
                      : "bg-red-50 text-red-700 border border-red-200"
                  }`}
                >
                  {status.msg}
                </div>
              )}

              <div>
                <label className="text-xs font-semibold text-slate-700">
                  Full Name
                </label>
                <input
                  name="name"
                  value={form.name}
                  onChange={onChange}
                  className="mt-1 w-full rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-[#7533AF]/30"
                  placeholder="John Doe"
                />
              </div>

              <div>
                <label className="text-xs font-semibold text-slate-700">
                  Email Address
                </label>
                <input
                  name="email"
                  value={form.email}
                  onChange={onChange}
                  type="email"
                  className="mt-1 w-full rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-[#7533AF]/30"
                  placeholder="john@example.com"
                />
              </div>

              <div>
                <label className="text-xs font-semibold text-slate-700">
                  Phone Number
                </label>
                <input
                  name="phone"
                  value={form.phone}
                  onChange={onChange}
                  className="mt-1 w-full rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-[#7533AF]/30"
                  placeholder="+1 (800) 123-4567"
                />
              </div>

              <div>
                <label className="text-xs font-semibold text-slate-700">
                  Message
                </label>
                <textarea
                  name="message"
                  value={form.message}
                  onChange={onChange}
                  rows="4"
                  className="mt-1 w-full rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-[#7533AF]/30"
                  placeholder="Tell us about your venue..."
                />
              </div>

              <button
                disabled={loading}
                className="w-full rounded-lg bg-[#7533AF] px-5 py-2 text-sm font-semibold text-white hover:opacity-90 shadow-sm disabled:opacity-60 disabled:cursor-not-allowed"
              >
                {loading ? "Sending..." : "Send Message"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
